import { Table } from './Table'
import { withTable } from './withTable'

const ConnectedTable = withTable(Table)

export { ConnectedTable as Table }
